import Vue from 'vue'
import VueRouter from 'vue-router'
// import HomeM from '../views/gb/mobile.vue'
import Home from '../views/home.vue'
import path from 'path'
import { buildHreflangTags, locationLocales } from '@/data/vpnHomeContent'

const SITE = 'https://www.vpn-free.com'
const hreflangAlternates = buildHreflangTags()

const locationRoutes = Object.entries(locationLocales).map(([localeKey, item]) => ({
	path: item.path,
	name: `${localeKey}-location`,
	meta: {
		appname: 'Secure VPN',
		localeKey,
		lang: item.htmlLang,
		title: item.title,
		keywords: `Secure VPN, ${item.label}`,
		description: item.description,
		alternates: hreflangAlternates,
		link: [{ rel: 'canonical', href: `${SITE}${item.path}` }],
	},
	component: Home,
}))
// import UAParser from 'ua-parser-js';
// const uaParser = new UAParser();
// const deviceInfo = uaParser.getResult();

// const isMobileDevice = deviceInfo.device.type === 'mobile';
Vue.use(VueRouter)

/* 解决访问重复路由报错问题：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx" 开始 */
const originalPush = VueRouter.prototype.push
// 修改 原型对象中的push方法
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err)
}
/* 解决访问重复路由报错问题：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx" 结束 */

export const constRoutesPc = [
	{
		path: '/',
		name: 'en-gb',
		meta: {
			appname: 'Secure VPN',
			lang: 'en',
			title: 'Secure VPN - Free VPN to Protect Your Privacy',
			keywords: 'Secure Free VPN, Free VPN App',
			description:
				'Protect your privacy with a secure free VPN. Download the VPN app for Android to enjoy encrypted browsing, fast global servers, and unlimited bandwidth.',
			alternates: hreflangAlternates,
			link: [
				{
					rel: 'canonical',
					href: 'https://www.vpn-free.com/',
				},
			],
		},
		component: Home,
	},
	{
		path: '/download/',
		name: 'en-download',
		// 保留尾斜杠，避免 Vue Router 默认把 /download/ 规范成 /download
		pathToRegexpOptions: { strict: true },
		meta: {
			appname: 'Secure VPN',
			title: 'Download Secure VPN APK – Free, Fast & Private Proxy',
			keywords: 'Free Secure VPN APK',
			description:
				'Download Secure VPN APK latest version for free. Enjoy a fast, secure, and ad-free VPN experience with private browsing and reliable connections.',
			link: [
				{
					rel: 'canonical',
					href: 'https://www.vpn-free.com/download/',
				},
			],
		},
		component: () => import('@/views/download.vue'),
	},
	// 无尾斜杠统一跳转到带尾斜杠地址
	{
		path: '/download',
		redirect: '/download/',
	},
	{
		path: '/for-windows/',
		name: 'en-for-windows',
		props: { pageKey: 'windows' },
		meta: {
			appname: 'Secure VPN',
			title: 'Free VPN for Windows \u2013 Download VPN for Windows PC 10 & 11',
			keywords: 'free VPN for Windows, VPN for Windows 10, VPN for Windows 11, Windows VPN download',
			description:
				'Download a free VPN for Windows 10 and 11. Connect to a VPN server, protect your connection on public Wi-Fi, and browse with more privacy on your Windows PC.',
			link: [
				{
					rel: 'canonical',
					href: 'https://www.vpn-free.com/for-windows/',
				},
			],
		},
		component: () => import('@/views/PlatformPage.vue'),
	},
	{
		path: '/for-mac/',
		name: 'en-for-mac',
		props: { pageKey: 'mac' },
		meta: {
			appname: 'Secure VPN',
			title: 'Download Free Unlimited VPN for Mac',
			keywords: 'free VPN for Mac, unlimited VPN for Mac, macOS VPN download, VPN for Mac',
			description:
				'Get a free unlimited VPN for Mac. Secure your connection, browse privately, and use a VPN on macOS with an easy setup.',
			link: [
				{
					rel: 'canonical',
					href: 'https://www.vpn-free.com/for-mac/',
				},
			],
		},
		component: () => import('@/views/PlatformPage.vue'),
	},
	{
		path: '/for-iphone/',
		name: 'en-for-iphone',
		props: { pageKey: 'iphone' },
		meta: {
			appname: 'Secure VPN',
			title: 'Free VPN for iPhone & iPad | VPN-Free',
			keywords: 'free VPN for iPhone, VPN for iPad, iOS VPN download, iPadOS VPN',
			description:
				'Get a free VPN for iPhone and iPad. Learn how to install and connect a VPN on iOS and iPadOS for secure, private browsing.',
			link: [
				{
					rel: 'canonical',
					href: 'https://www.vpn-free.com/for-iphone/',
				},
			],
		},
		component: () => import('@/views/PlatformPage.vue'),
	},
	{
		path: '/for-linux/',
		name: 'en-for-linux',
		props: { pageKey: 'linux' },
		meta: {
			appname: 'Secure VPN',
			title: 'Free VPN for Linux \u2013 Secure & Private VPN for Linux',
			keywords: 'free VPN for Linux, Linux VPN download, secure VPN for Linux, private VPN for Linux',
			description:
				'Get a free VPN for Linux to protect your internet connection, hide your IP address, and browse privately. Easy VPN setup for Linux users.',
			link: [
				{
					rel: 'canonical',
					href: 'https://www.vpn-free.com/for-linux/',
				},
			],
		},
		component: () => import('@/views/PlatformPage.vue'),
	},
	{
		path: '/for-chrome/',
		name: 'en-for-chrome',
		props: { pageKey: 'chrome' },
		meta: {
			appname: 'Secure VPN',
			title: 'Free VPN for Chrome \u2013 Fast & Secure Chrome VPN Extension',
			keywords: 'free VPN for Chrome, Chrome VPN extension, secure Chrome VPN, private browsing VPN',
			description:
				'Get a free VPN for Chrome to browse privately, hide your IP address, and secure your browser traffic. Easy to install and use with one click.',
			link: [
				{
					rel: 'canonical',
					href: 'https://www.vpn-free.com/for-chrome/',
				},
			],
		},
		component: () => import('@/views/PlatformPage.vue'),
	},
	{
		path: '/for-firefox/',
		name: 'en-for-firefox',
		props: { pageKey: 'firefox' },
		meta: {
			appname: 'Secure VPN',
			title: 'Free VPN for Firefox | Secure & Private Firefox Extension',
			keywords: 'free VPN for Firefox, Firefox VPN extension, secure Firefox VPN, private browser VPN',
			description:
				'Use a free VPN for Firefox to protect browser traffic, hide your IP address, and browse more privately. Install the VPN extension and connect in a few clicks.',
			link: [
				{
					rel: 'canonical',
					href: 'https://www.vpn-free.com/for-firefox/',
				},
			],
		},
		component: () => import('@/views/PlatformPage.vue'),
	},
	{
		path: '/free-proxy-list/',
		alias: '/free-proxy-list',
		name: 'en-free-proxy-list',
		meta: {
			appname: 'Secure VPN',
			title: 'Free Proxy List & Protocols Guide (HTTP, HTTPS, SOCKS5) | Secure VPN',
			keywords: 'Free Proxy List, HTTP Proxy, HTTPS Proxy, SOCKS5 Proxy, SOCKS4 Proxy',
			description:
				'Learn how HTTP, HTTPS, SOCKS4, and SOCKS5 proxies work. Compare proxy anonymity levels and protocol differences for secure data routing and web testing.',
			link: [
				{
					rel: 'canonical',
					href: 'https://www.vpn-free.com/free-proxy-list/',
				},
			],
		},
		component: () => import('@/views/free-proxy-list.vue'),
	},
	{
		path: '/blog/',
		alias: '/blog',
		name: 'en-blog',
		meta: {
			appname: 'Secure VPN',
			title: 'VPN Hot Topics and Resources | Blog',
			keywords: 'VPN Blog, VPN Guides, Proxy Resources, Online Privacy',
			description:
				'Explore VPN topics, guides, tips, and resources to learn more about VPNs, Proxies, online privacy, security, and popular VPN services.',
			link: [
				{
					rel: 'canonical',
					href: 'https://www.vpn-free.com/blog/',
				},
			],
		},
		component: () => import('@/views/blog.vue'),
	},
	{
		path: '/is-nordvpn-free-how-to-get-free-trial/',
		alias: '/is-nordvpn-free-how-to-get-free-trial',
		name: 'en-nordvpn-free-trial',
		meta: {
			appname: 'Secure VPN',
			title: 'Is NordVPN Free? How to Get the NordVPN Free Trial in 2026',
			keywords: 'Is NordVPN Free, NordVPN Free Trial, NordVPN Trial 2026, Free VPN Alternatives',
			description:
				'Is NordVPN free in 2026? Learn how the NordVPN free trial works, how long it lasts, what happens after the trial, and free VPN alternatives.',
			link: [
				{
					rel: 'canonical',
					href: 'https://www.vpn-free.com/is-nordvpn-free-how-to-get-free-trial/',
				},
			],
		},
		component: () => import('@/views/nordvpn-free-trial.vue'),
	},
	{
		path: '/10-best-yesmovies-alternative-legal/',
		alias: '/10-best-yesmovies-alternative-legal',
		name: 'en-yesmovies-alternatives',
		meta: {
			appname: 'Secure VPN',
			articleKey: 'yesMoviesAlternatives',
			title: '10 Best YesMovies Alternatives in 2026: Legal Free and Paid Options',
			keywords:
				'YesMovies alternatives, legal streaming sites, free streaming sites, paid streaming services, movie streaming 2026',
			description:
				'Looking for a YesMovies alternative? See the best free and paid streaming sites in 2026, what each is best for, and how Secure VPN can help with regional access.',
			link: [
				{
					rel: 'canonical',
					href: 'https://www.vpn-free.com/10-best-yesmovies-alternative-legal/',
				},
			],
		},
		component: () => import('@/views/vpn-blog-article.vue'),
	},
	{
		path: '/10-platforms-to-watch-boxing-live-stream/',
		alias: '/10-platforms-to-watch-boxing-live-stream',
		name: 'en-boxing-live-stream',
		meta: {
			appname: 'Secure VPN',
			articleKey: 'boxingLiveStream',
			title: 'Boxing Live Stream: 10 Best Ways to Watch Boxing Online in 2026',
			keywords:
				'boxing live stream, watch boxing online, boxing streaming platforms, legal boxing streams, boxing 2026',
			description:
				'Want to watch a boxing fight live? Find where to stream major boxing events, which platforms offer the best coverage, and what to check before the fight starts.',
			link: [
				{
					rel: 'canonical',
					href: 'https://www.vpn-free.com/10-platforms-to-watch-boxing-live-stream/',
				},
			],
		},
		component: () => import('@/views/vpn-blog-article.vue'),
	},
	{
		path: '/10-best-fmovies-alternatives-free-legal-sites/',
		alias: '/10-best-fmovies-alternatives-free-legal-sites',
		name: 'en-fmovies-alternatives',
		meta: {
			appname: 'Secure VPN',
			articleKey: 'fmoviesAlternatives',
			title: '10 Best FMovies Alternatives: Free & Legal Movie Sites',
			keywords:
				'FMovies alternatives, legal movie sites, free movie streaming, Tubi, Pluto TV, paid streaming services',
			description:
				'Looking for FMovies alternatives? Compare 10 legal movie streaming services, including free options like Tubi and Pluto TV and paid platforms like Netflix.',
			link: [
				{
					rel: 'canonical',
					href: 'https://www.vpn-free.com/10-best-fmovies-alternatives-free-legal-sites/',
				},
			],
		},
		component: () => import('@/views/vpn-blog-article.vue'),
	},
	{
		path: '/nordvpn-vs-expressvpn-for-streaming-which-is-better/',
		alias: '/nordvpn-vs-expressvpn-for-streaming-which-is-better',
		name: 'en-nordvpn-vs-expressvpn-streaming',
		meta: {
			appname: 'Secure VPN',
			articleKey: 'nordvpnVsExpressvpnStreaming',
			title: 'NordVPN vs ExpressVPN for Streaming: Which Is Better?',
			keywords:
				'NordVPN vs ExpressVPN, streaming VPN, Netflix VPN, 4K streaming, VPN stability',
			description:
				'Compare NordVPN and ExpressVPN for streaming, including region coverage, Netflix, 4K quality, stability, speed, and support for popular streaming services.',
			link: [
				{
					rel: 'canonical',
					href: 'https://www.vpn-free.com/nordvpn-vs-expressvpn-for-streaming-which-is-better/',
				},
			],
		},
		component: () => import('@/views/vpn-blog-article.vue'),
	},
	{
		path: '/about-us/',
		alias: '/about-us',
		name: 'en-about-us',
		meta: {
			appname: 'Secure VPN',
			title: 'About Us – Privacy & Secure Internet Access',
			keywords: 'Secure VPN About Us, VPN Privacy, Secure Internet Access',
			description:
				'Learn about Secure VPN, our mission, and how we help users understand VPN technology, online privacy, and secure internet connections.',
			link: [
				{
					rel: 'canonical',
					href: 'https://www.vpn-free.com/about-us/',
				},
			],
		},
		component: () => import('@/views/about-us.vue'),
	},
	{
		path: '/contact-us/',
		alias: '/contact-us',
		name: 'en-contact-us',
		meta: {
			appname: 'Secure VPN',
			title: 'Contact Us – Support & Feedback',
			keywords: 'Secure VPN Contact, VPN Support, VPN Feedback',
			description:
				'Contact Secure VPN for questions, feedback, or website-related inquiries. We are happy to receive your suggestions and requests.',
			link: [
				{
					rel: 'canonical',
					href: 'https://www.vpn-free.com/contact-us/',
				},
			],
		},
		component: () => import('@/views/contact-us.vue'),
	},
	{
		path: '/privacy-policy/',
		alias: '/privacy-policy',
		name: 'en-privacy-policy',
		meta: {
			appname: 'Secure VPN',
			title: 'Privacy Policy - Secure VPN',
			keywords: 'Secure VPN Privacy Policy, VPN Privacy, Website Privacy',
			description:
				'Read the Secure VPN Privacy Policy to learn how we collect and use limited website information, cookies, analytics, and advertising data.',
			link: [
				{
					rel: 'canonical',
					href: 'https://www.vpn-free.com/privacy-policy/',
				},
			],
		},
		component: () => import('@/views/privacy.vue'),
	},
	{
		path: '/terms-of-use/',
		alias: '/terms-of-use',
		name: 'en-terms-of-use',
		meta: {
			appname: 'Secure VPN',
			title: 'Terms of Use – Website Usage Rules',
			keywords: 'Secure VPN Terms of Use, Website Usage Rules',
			description:
				'Review Secure VPN Terms of Use to understand website rules, user responsibilities, and conditions for accessing our content.',
			link: [
				{
					rel: 'canonical',
					href: 'https://www.vpn-free.com/terms-of-use/',
				},
			],
		},
		component: () => import('@/views/terms-of-use.vue'),
	},
	{
		path: '/disclaimer/',
		alias: '/disclaimer',
		name: 'en-disclaimer',
		meta: {
			appname: 'Secure VPN',
			title: 'Disclaimer – Important Information',
			keywords: 'Secure VPN Disclaimer, VPN Disclaimer',
			description:
				'Read the Secure VPN Disclaimer for information about website content, third-party services, and user responsibilities.',
			link: [
				{
					rel: 'canonical',
					href: 'https://www.vpn-free.com/disclaimer/',
				},
			],
		},
		component: () => import('@/views/disclaimer.vue'),
	},
	...locationRoutes,

]


let routes = []
// if (isMobileDevice) {
// 	routes = constRoutesM
// }
// if (!isMobileDevice) {
// 	routes = constRoutesPc
// }

routes = constRoutesPc
export default function createRouter() {
	const router = new VueRouter({
		mode: 'history',
		routes,
		scrollBehavior(to, from, savedPosition) {
			if (savedPosition) {
				return savedPosition
			}
			if (to.hash) {
				return { selector: to.hash, behavior: 'smooth' }
			}
			return { x: 0, y: 0 }
		},
	})

	// 客户端兜底：地址栏若是 /download，强制落到 /download/
	router.beforeEach((to, from, next) => {
		const isStaticFile = /\.[a-z0-9]+$/i.test(to.path)
		if (to.path !== '/' && !to.path.endsWith('/') && !isStaticFile) {
			next({
				path: `${to.path}/`,
				query: to.query,
				hash: to.hash,
				replace: true,
			})
			return
		}
		if (to.path === '/download') {
			next({ path: '/download/', query: to.query, hash: to.hash, replace: true })
			return
		}
		next()
	})

	return router
}
